import { useEffect, useState } from "react";

const OTPnumber = (props:any ) => {
  const [enteredvalue, setenteredvalue] = useState("");
  const [chars_, setchars] = useState(enteredvalue.split(""));

  const onBackpresed = () => {
    setenteredvalue((prevValue) => prevValue.slice(0, -1));
  };
  const onchange = (e: any) => {
    var value = e.target.value;
    if (enteredvalue.length <4) {
      setenteredvalue((val) => val + value.charAt(value.length - 1));
    }
  };

  useEffect(() => {
    setchars(enteredvalue.split(""));
    let oneinput = document.getElementById("one") as HTMLInputElement;
    let twoinput = document.getElementById("two") as HTMLInputElement;
    let threeinput = document.getElementById("three") as HTMLInputElement;
    let fourinput = document.getElementById("four") as HTMLInputElement;
    let chars = enteredvalue.split("");
    var length = chars.length;
    console.log(length);

    oneinput.value = chars[0];
    chars[0] && oneinput.focus();

    twoinput.value = chars[1];
    chars[1] && twoinput.focus();

    threeinput.value = chars[2];
    chars[2] && threeinput.focus();

    fourinput.value = chars[3];
    chars[3] && fourinput.focus();

    console.log(chars);
    props.setEntered(enteredvalue)
  }, [enteredvalue]);
  return (
    <div className="  flex justify-center items-center my-3">
      <input
        type="number"
        id="one"
        value={chars_[0]}
        placeholder="0"

        min="0"
        onKeyDown={(e) => {
          if (e.key === "Backspace") {
            onBackpresed();
          }
        }}
        onChange={onchange}
        max="9"
        maxLength={1}
        className=" placeholder-gray-200 singleDigit bg-white m-1 px-3 font-bold  py-4 w-12 h-12 single-digit-input custom-outline  rounded-[8px]    text-primary border-2 border-faint text-[24px]  
    "
      />
      <input
        type="number"
        value={chars_[1]}
        placeholder="0"

        id="two"
        onChange={onchange}
        onKeyDown={(e) => {
          if (e.key === "Backspace") {
            onBackpresed();
          }
        }}
        min="0"
        max="9"
        maxLength={1}
        className="bg-white placeholder-gray-200  font-bold text-primary  singleDigit m-1 px-3 py-4 w-12 h-12 single-digit-input custom-outline  rounded-[8px]  border-2 border-faint text-[24px]  
    "
      />
      <input
        type="number"
        id="three"
        value={chars_[2]}
        min="0"
        placeholder="0"

        onKeyDown={(e) => {
          if (e.key === "Backspace") {
            onBackpresed();
          }
        }}
        onChange={onchange}
        max="9"
        maxLength={1}
        className="bg-white  placeholder-gray-200  singleDigit font-bold text-primary m-1 px-3 py-4 w-12 h-12 single-digit-input custom-outline  rounded-[8px]  border-2 border-faint text-[24px]  
    "
      />
      <input
        type="number"
        id="four"
        min="0"
        placeholder="0"
        value={chars_[3]}
        max="9"
        onChange={onchange}
        onKeyDown={(e) => {
          if (e.key === "Backspace") {
            onBackpresed();
          }
        }}
        maxLength={1}
        className="bg-white   placeholder-gray-200  singleDigit font-bold text-primary m-1 px-3 py-4 w-12 h-12 single-digit-input custom-outline  rounded-[8px]  border-2 border-faint text-[24px]  
    "
      />
    </div>
  );
};

export { OTPnumber };
